import { ChevronLeft, ChevronRight, XClose } from '@untitledui/icons'
import { twJoin } from 'tailwind-merge'

import { useHeaderContext } from '@/lib/provider/HeaderContext'
import Button from '@components/designSystem/Button'
import { useDayScans } from '@hooks/useDayScans'
import { useIsWideLayout } from '@hooks/useMediaQuery.ts'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { formatObservationTime } from '@utils/dates'

/** Says that the map shows one scan, which one, and how to get to another one or back to the day. */
function ScanModeBar() {
  const { t, i18n } = useTypedTranslation()
  const isWideLayout = useIsWideLayout()
  const { isFullPage } = useHeaderContext()
  const { selected, newer, older, showScan } = useDayScans()

  const className = twJoin(
    'absolute z-50 flex gap-1 border border-border-secondary bg-bg-primary py-1 pr-1 pl-3 text-xs shadow-sm',
    isWideLayout && 'left-1/2 -translate-x-1/2 items-center rounded-full',
    isWideLayout && (isFullPage ? 'top-25' : 'top-0'),
    // below the back button and clear of the toolbar on the right
    !isWideLayout && 'top-16 left-3 flex-col items-start rounded-2xl'
  )

  return (
    <div className={className}>
      {selected && (
        <p className='pr-1 font-medium whitespace-nowrap' data-testid='scan-mode-line'>
          {t('storeMap.scanMode.line', {
            time: formatObservationTime(new Date(selected.scanDate), i18n.language),
            route: selected.floor,
          })}
        </p>
      )}
      <div className='flex gap-1'>
        {selected && (
          <>
            <Button
              variant='outline'
              size='sm'
              aria-label={t('storeMap.scanMode.older')}
              isDisabled={!older}
              onClick={() => older && showScan(older.id)}
              iconLeading={<ChevronLeft />}
            />
            <Button
              variant='outline'
              size='sm'
              aria-label={t('storeMap.scanMode.newer')}
              isDisabled={!newer}
              onClick={() => newer && showScan(newer.id)}
              iconLeading={<ChevronRight />}
            />
          </>
        )}
        <Button
          variant='outline'
          size='sm'
          data-testid='scan-mode-exit'
          aria-label={t('storeMap.scanMode.exit')}
          onClick={() => showScan(null)}
          iconLeading={<XClose />}
        />
      </div>
    </div>
  )
}

export default ScanModeBar
